import { createClient } from "@supabase/supabase-js"


function getLunch() {
    return new Promise((resolve, reject) => {
      const supabase = createClient("https://hgchgftqfrtsdtadzdqw.supabase.co", process.env.REACT_APP_SUPABASE_KEY)
      supabase.from("Test").select("*").then(res => {
        console.log(res)
      })
      supabase.functions.invoke("get-lunch").then(res => {
        resolve(res.data)
})
// fetch("https://gist.githubusercontent.com/js802025/067f545ffe3b2b071524e043f227954a/raw/").then(response => response.json().then(data => {
//   resolve(data)
// }))
    })
}

function getMX() {
    return new Promise((resolve, reject) => {
   //  fetch("https://mx-2s6pv32ija-uc.a.run.app/api/external/upcoming?sub="+process.env.REACT_APP_MX_KEY).then(response => response.json().then(data => {
//       console.log(data)
//       //  var text = data.split("y,")
//       //   var parser = new DOMParser();
       
//       // var m = {}
//       // console.log(data)
//       //  var parsedMX = parser.parseFromString(data, "text/html")
//       //  console.log(parsedMX)
//       //   Array.from(parsedMX.getElementsByTagName("ul")[0].children).forEach(element => {
//       //     if (element.getElementsByTagName("ul").length === 0) {
//       //       var date = new Date(element.innerText.split(":")[0].replace("th", "").replace("st", "").replace("nd", "").replace("rd", "") + " "+new Date().getFullYear())
//       //       m[date.toDateString().split(" ").slice(0, 3).join(" ")] = element.innerText.split(":").slice(1)
//       //     } else {
//       //       var date = new Date(element.innerText.split(":")[0].replace("th", "").replace("st", "").replace("nd", "").replace("rd", "") + " "+new Date().getFullYear())
//       //       m[date.toDateString().split(" ").slice(0, 3).join(" ")] = Array.from(element.getElementsByTagName("ul")[0].children).map(e => e.innerText)
//       //     }
//       //   });
    
//     //   var text = data.split("y,")
//     //  console.log(text)
//     //  var m = {}
//     //   var weekdays = ["Monda", "Tuesda", "Wednesda", "Thursda", "Frida"]
//     //   for (var e of text.slice(1)) {
//     //     var i = e.split("\n")
//     //   //  console.log(i[0].split(":")[0].replace("th", "").replace("st", "").replace("nd", "").replace("rd", "") + " 2023")
//     //     var date = new Date(i[0].split(":")[0].replace("th", "").replace("st", "").replace("nd", "").replace("rd", "") + " "+new Date().getFullYear())
//     //    // console.log(date)
//     //     console.log(i.slice(-1)[0])
//     //     if (weekdays.includes(i.slice(-1)[0].replaceAll(" ", ""))) {
          
//     //       i.splice(-1)
          
//     //     } //else {
//     //     //   console.log(i.slice(-1)[0])
//     //     //   i[i.length-1] = i[i.length-1].slice(0, -1)
//     //     //   //console.log(i)
//     //     // }
//     //  //   console.log(i)
//     //     m[date.toDateString().split(" ").slice(0, 3).join(" ")] = i.slice(1)
        
//     //     }
//     //  console.log(m)
//       resolve(data)
// })

var data = [{"id":41,"date":"2024-09-18","owner":{"id":8,"sub":"117719372804900691682","picture":"https://lh3.googleusercontent.com/a/ACg8ocIoFbhGfa9wJ2Y4dbhjOJqo8HjtWt067joGWtzWpMo_IJIBxA=s96-c","email":"mx@fwparker.org","name":"Morning Ex","token":"ya29.a0AcM612xNbFYOHyCfwEQ7P_Uo4YhvpIUKjawSM3gMrBPgT1A7JUlqTz-c2VBqxPXTgS3HtadoVf97yE2ij02TVh8L9tskp8ff0sFjzGaiOlhF6fZuSmRqCWlrdlm8A3s3xUxzLgKQjyXlTG40Th0zvZo3z2y4I1K6VbYd7AgLaCgYKAaISARISFQHGX2Mi2xTaIWoGFy-1UdmBpry9mA0175","phone_number":null,"is_admin":true},"title":"Homecoming MX","description":"First Homecoming MX ","min_grade":0,"max_grade":13,"young_student_prep_instructions":"","is_available_in_day":false,"required_tech_json":["Projector/Screen","Additional handheld microphones","",""],"short_description":"Extension of an UPPER SCHOOL course or activity\n","editors_json":[],"is_approved":true},{"id":42,"date":"2024-09-30","owner":{"id":8,"sub":"117719372804900691682","picture":"https://lh3.googleusercontent.com/a/ACg8ocIoFbhGfa9wJ2Y4dbhjOJqo8HjtWt067joGWtzWpMo_IJIBxA=s96-c","email":"mx@fwparker.org","name":"Morning Ex","token":"ya29.a0AcM612xNbFYOHyCfwEQ7P_Uo4YhvpIUKjawSM3gMrBPgT1A7JUlqTz-c2VBqxPXTgS3HtadoVf97yE2ij02TVh8L9tskp8ff0sFjzGaiOlhF6fZuSmRqCWlrdlm8A3s3xUxzLgKQjyXlTG40Th0zvZo3z2y4I1K6VbYd7AgLaCgYKAaISARISFQHGX2Mi2xTaIWoGFy-1UdmBpry9mA0175","phone_number":null,"is_admin":true},"title":"Stenn civics MX","description":"Civics Speaker","min_grade":10,"max_grade":13,"young_student_prep_instructions":"","is_available_in_day":false,"required_tech_json":["Projector/Screen","",""],"short_description":"Outside Speaker\n","editors_json":[],"is_approved":true},{"id":43,"date":"2024-10-10","owner":{"id":8,"sub":"117719372804900691682","picture":"https://lh3.googleusercontent.com/a/ACg8ocIoFbhGfa9wJ2Y4dbhjOJqo8HjtWt067joGWtzWpMo_IJIBxA=s96-c","email":"mx@fwparker.org","name":"Morning Ex","token":"ya29.a0AcM612xNbFYOHyCfwEQ7P_Uo4YhvpIUKjawSM3gMrBPgT1A7JUlqTz-c2VBqxPXTgS3HtadoVf97yE2ij02TVh8L9tskp8ff0sFjzGaiOlhF6fZuSmRqCWlrdlm8A3s3xUxzLgKQjyXlTG40Th0zvZo3z2y4I1K6VbYd7AgLaCgYKAaISARISFQHGX2Mi2xTaIWoGFy-1UdmBpry9mA0175","phone_number":null,"is_admin":true},"title":"County Fair MX","description":"Introduce County Fair Booths","min_grade":0,"max_grade":13,"young_student_prep_instructions":"","is_available_in_day":false,"required_tech_json":["Projector/Screen","Additional handheld microphones","",""],"short_description":"Extension of a LOWER SCHOOL course or activity\n","editors_json":[],"is_approved":true}]
var mxes = {}
data.forEach((d) => {
  var date = new Date(d.date + "CDT")
  var dateString = date.toDateString().split(" ").slice(0, 3).join(" ")
  mxes[dateString] = [d.title, d.description]
})
resolve(mxes)

//})
  //   ).catch((err) => {
  //     console.log(err)
  //     resolve({})
  //   })
  // }
  // )
})
}
export { getLunch, getMX };